import ClientDeposit from './clientdeposit';
export default class ClientDepositContainer {
  clientNumber: number = 0;
  sequenceNumber: number = 0;
  depositDate: Date = null;
  deposits: Array<ClientDeposit>;
}


// WEBPACK FOOTER //
// ./src/components/accounts-receivable/models/clientdepositcontainer.ts